import { Reducer } from "redux";

import { GetReferralSearchListActionDispatchTypes } from "../constants/HomePage";
import { ReferralDetailsResponse, ReferralSearchResponse } from "../models/api/Referral";
import { ReferralSearchListDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: ReferralSearchResponse = {
  loading: false,
  response: [
    {
      referralId: 0,
      authorizationNumber: "",
      referralStatusName: "",
      minEffectiveFromDate: "",
      maxEffectiveThroughDate: "",
      sn: 0,
      pt: 0,
      ot: 0,
      st: 0,
      msw: 0,
      hha: 0,
      lastName: "",
      firstName: "",
      dateOfBirth: "",
      gender: "",
      medicareBeneficiaryIdentifier: "",
      patientId: 0,
      totalRows: 0,
      authorizationTypeName: "",
      subscriberId: "",
      reimbursementTypeId: 0,
      reimbursementTypeName: "",
      benefitPlan: "",
    },
  ],
  error: null,
};

const ReferralSearchReducer: Reducer<
  ReferralDetailsResponse,
  ReferralSearchListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ReferralSearchReducer;
